import React from "react";
import { PriorityChip, StatusChip } from "./Chips";
import {
  AntiguedadCell,
  CadeteCell,
  CantidadCell,
  ComercioCell,
  DuracionCell,
  EstadoCell,
  FechasCell,
  FinCadeteCell,
  PedidaEntregadaCell,
  ProximaAccionCell,
  RecibioCell,
  ResponsableCell,
  UltimaEntregaCell,
  isSpotlight,
  newBadge,
} from "./rolloCells";

// Column headers of each table, before the action column.
const ACTIVAS_HEADERS = [
  { label: "Comercio" },
  { label: "Estado" },
  { label: "Cantidad", className: "crm-rollo__num" },
  { label: "Antigüedad" },
  { label: "Última entrega" },
  { label: "Cadete" },
  { label: "Prioridad" },
  { label: "Responsable" },
  { label: "Próx. acción" },
];

const FINALIZADAS_HEADERS = [
  { label: "Comercio" },
  { label: "Resultado" },
  { label: "Pedida / entregada" },
  { label: "Fechas" },
  { label: "Duración" },
  { label: "Cadete" },
  { label: "Recibió / motivo" },
  { label: "Responsable" },
];

// Columns of each table with the action column, so the loading skeleton has the same shape.
export const ACTIVAS_COLUMNS = ACTIVAS_HEADERS.length + 1;
export const FINALIZADAS_COLUMNS = FINALIZADAS_HEADERS.length + 1;

const HeaderRow = ({ headers }) => (
  <tr>
    {headers.map(({ label, className }) => (
      <th key={label} scope="col" className={className}>
        {label}
      </th>
    ))}
    <th scope="col">
      <span className="crm-rollo__sr-only">Acción</span>
    </th>
  </tr>
);

// is-spotlight: row pointed at ("Ver gestión abierta") or just created; is-new adds the "Nueva" tag.
const rowClass = (item, busyId, spotlight) =>
  [
    busyId === item.id ? "is-busy" : "",
    isSpotlight(item, spotlight) ? "is-spotlight" : "",
    isSpotlight(item, spotlight) && spotlight.isNew ? "is-new" : "",
  ]
    .filter(Boolean)
    .join(" ") || undefined;

// DataTable of Activas (design RolloQueue). The card scrolls sideways when the columns do not fit.
export function ActivasTable({ items, currentUserId, today, busyId, spotlight = null, diasParaDemora = null, renderActions }) {
  return (
    <div className="crm-rollo__table-wrap">
      <table className="crm-rollo__table">
        <thead>
          <HeaderRow headers={ACTIVAS_HEADERS} />
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className={rowClass(item, busyId, spotlight)} aria-busy={busyId === item.id || undefined}>
              <td className="crm-rollo__cell--comercio">
                <ComercioCell item={item} badge={newBadge(item, spotlight)} />
              </td>
              <td className="crm-rollo__cell--estado">
                <EstadoCell item={item} />
              </td>
              <td className="crm-rollo__num">
                <CantidadCell item={item} />
              </td>
              <td className="crm-rollo__nowrap">
                <AntiguedadCell item={item} diasParaDemora={diasParaDemora} />
              </td>
              <td className="crm-rollo__nowrap">
                <UltimaEntregaCell item={item} />
              </td>
              <td className="crm-rollo__nowrap">
                <CadeteCell item={item} />
              </td>
              <td>
                <PriorityChip prioridad={item.prioridad} />
              </td>
              <td className="crm-rollo__nowrap">
                <ResponsableCell item={item} currentUserId={currentUserId} />
              </td>
              <td className="crm-rollo__cell--next">
                <ProximaAccionCell item={item} today={today} />
              </td>
              <td>{renderActions(item)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// DataTable of Finalizadas (design RolloFinalizadas): closing columns instead of the queue ones.
export function FinalizadasTable({ items, currentUserId, renderActions }) {
  return (
    <div className="crm-rollo__table-wrap">
      <table className="crm-rollo__table">
        <thead>
          <HeaderRow headers={FINALIZADAS_HEADERS} />
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className="crm-rollo__cell--comercio">
                <ComercioCell item={item} />
              </td>
              <td>
                <StatusChip estado={item.estado} />
              </td>
              <td className="crm-rollo__nowrap">
                <PedidaEntregadaCell item={item} />
              </td>
              <td className="crm-rollo__nowrap">
                <FechasCell item={item} />
              </td>
              <td className="crm-rollo__nowrap">
                <DuracionCell item={item} />
              </td>
              <td className="crm-rollo__nowrap">
                <FinCadeteCell item={item} />
              </td>
              <td className="crm-rollo__cell--recibio">
                <RecibioCell item={item} />
              </td>
              <td className="crm-rollo__nowrap">
                <ResponsableCell item={item} currentUserId={currentUserId} />
              </td>
              <td>{renderActions(item)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
